import { TeamInfoModal } from "@meitu/xdesign-widgets/dist/teamExports";
import { openVipModal } from "@/utils/login";
import { statTrack } from "@/utils/mtstat";
import React from "react";

function TeamInfo() {
  const handleOpenVip = (params: Record<string, any> = {}) => {
    openVipModal(params);
  };

  return (
    <>
      <TeamInfoModal
        onChange={() => {
          window.location.reload();
        }}
        onOpenVipModal={(params) => {
          handleOpenVip(params);
        }}
        onTrack={statTrack}
      />
    </>
  );
}

export default React.memo(TeamInfo);
